module.exports = __webpack_public_path__ + "img/nick-link-icon-secondary_2x.90d782a.png";